import React from 'react';
import styled, { css } from 'styled-components';
import * as _ from 'underscore';
import * as d3 from 'd3';
import $ from "jquery";
import {colorLookup,colorLookupSDG} from '../utils/colorHash';
const color = colorLookup;
const sdg_color = colorLookupSDG;

const sizeLookup = {
  'Between 10 and 249': [10,249],
  'Between 250 and 5K': [250, 4999],
  'Between 5K and 50K' : [5000,50000],
  'Greater than 50K': [50001,Infinity]
}

const Wrapper = styled.div`
  top: 70px;
  position: relative;
  width: 90%;
  left: 5%;
  & ::selection {
    background: none;
    color: none;
    }
`
const Notes = styled.p`
  color: white;
  position: relative;
  bottom: 5px;
  padding: 10px 0 30px 0;
  font-size: 11px;
`
const ChartContainer = styled.div`
  margin-top: ${props => props.className != 'Between10and249' ? '70px' : '10px'}
  position: relative;

  &>p{
    color: white;
    font-weight: 300;
    font-size: 18px;
    font-family: 'Roboto';
    cursor: pointer;
    transition: all 400ms;
  }
  &>p:hover{
    color: #c7d2f3;
  }
  &>p:nth-child(2){
    position: absolute;
    top: -5px;
    right: 0;
    font-size: 30px;
    cursor: pointer;
  }
  &>p>em{
    font-weight: 400;
    font-style: normal;
  }

  &>svg{
    width: 100%;
    height: ${props => props['svg-H']};
    ${props => !props.currentOpenedTab.includes(props.className) && css`display: none;`}
  }

  &::before{
    content: '';
    width: 100%;
    height: 2px;
    position: absolute;
    background: #ffffff6e;
    top: 35px;
  }
`
const ModeContainer = styled.div`
  height: 50px;
  top: 5px;
  position: relative;
`
const ModeSwitcher = styled.div`
  color: white;
  cursor: pointer;
  background: ${props => props.currentMode === props.mode ? "#6387CE" : "#141425"};
  position: relative;
  display: inline;
  padding: 2px 10px;
  border-radius: 2px;
  box-shadow: 4px 12px 58px -8px rgba(0,0,0,0.75);
  width: 160px;
  border-radius: 3px;
  margin: 0 30px 10px 0;
  border-bottom: 2px solid #ccc;
`
const LegendContainer = styled.div`
  position: relative;
  top: 0px;

  ${props => !props.currentOpenedTab.includes(props.tabName) && css`display: none;`}
`

export default class CompanySizeChart extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      mode: 'absoluteNum',
      svg_height: '150px',
      currentOpenedTab:['Between250and5K'],
    }

    this.currentSelectedItem = props.currentSelectedItem;
    this.data = props.data;
    this.list = props.list;

    this.generateChartContainer = this.generateChartContainer.bind(this);
    this.calculateChart = this.calculateChart.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
  }

  componentWillReceiveProps(nextProps){
    this.currentSelectedItem = nextProps.currentSelectedItem;
    this.data = nextProps.data;
    this.list = nextProps.list;

    if(this.list[this.currentSelectedItem]['multiselect']) this.setState({svg_height: '300px'},() => {this.calculateChart()});
    else this.setState({svg_height: '150px'},() => {this.calculateChart()});
    this.calculateChart();
  }

  componentDidMount(){
    if(this.list[this.currentSelectedItem]['multiselect']) this.setState({svg_height: '300px'},() => {this.calculateChart()});
    else this.setState({svg_height: '150px'},() => {this.calculateChart()});
    this.calculateChart();
  }

  handleTabClick(categoryName){
    this.state.currentOpenedTab.includes(categoryName)
      ? this.setState({currentOpenedTab: this.state.currentOpenedTab.filter(d => d != categoryName)})
      : this.setState({ currentOpenedTab: this.state.currentOpenedTab.concat([categoryName]) })
  }

  calculateChart(){
    // iterate through the lookup table to generate chart
    Object.keys(sizeLookup).forEach(d =>{
      const className = '.' + d.replace(/\s/gi,'');
      d3.select(className).select('svg').select('.graphLayer').selectAll('*').remove();
      const margin = {top: 20, right: 50, bottom: 20, left: 0};

      const width = $(className).find('svg').width() - margin.left - margin.right;
      const height = $(className).find('svg').height() - margin.top - margin.bottom;

      this.g = d3.select(className).select('svg')
        .attr('overflow',"visible")
        .select('.graphLayer')
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      const currentSelectedKey = this.list[this.currentSelectedItem]['key'][0];
      const optionMap = this.list[this.currentSelectedItem]['optionMap'];
      const options = Object.keys(optionMap);
      const companySizeRangeBound = sizeLookup[d];
      const optionCount = Object.keys(optionMap).reduce((o, key) => ({ ...o, [key]: 0}), {});
      var breakdownCounter = 0;
      var totalCounter = 0;
      var totalRecords;
      const vizData = this.data.reduce((a, d) => {
        totalCounter++;
        if(+d['Number_of_Employees'] >= companySizeRangeBound[0] && +d['Number_of_Employees'] <= companySizeRangeBound[1]){
          const data = d[currentSelectedKey];
          if(typeof data ==='number'){
            breakdownCounter++;
            a[data]++;
          }else if (typeof data === 'string') {
            breakdownCounter++;
            data.split(',').forEach(_d =>{
              if(_d != ""){
                a[_d]++;
              }
            })
          }
        }
        return a;
      },optionCount);

      if(this.state.mode === 'percentage') totalRecords = breakdownCounter;
      else if (this.state.mode === 'absoluteNum') totalRecords = totalCounter;

      const xScale = d3.scaleLinear().domain([0,totalRecords]).range([0,width]);
      const yScale = this.list[this.currentSelectedItem]['multiselect']
        ? d3.scaleBand().domain(options).rangeRound([0- margin.top,height]).padding([.5])
        : d3.scaleBand().domain(['2018']).rangeRound([height,0]).padding([.5]);

      const stack = d3.stack().keys(options.reverse())
      // .order(d3.stackOrderDescending);
      const stackedSeries = stack([vizData]);
      let keyCounter = 0;

      this.breakdownByCompanySize = this.list[this.currentSelectedItem]['multiselect']
      ? this.g.selectAll('rect').data((() =>{const out = [];Object.keys(vizData).forEach(_d =>{out.push({key:_d,value: vizData[_d]})}); return out;})())
        .enter().append("rect")
        .attr("fill",_d =>{
          if(this.list[this.currentSelectedItem]['SDGColor']){
            return sdg_color(+_d.key);
          }
          return color(_d.key);
        })
        .attr("y",_d=> yScale(_d.key))
        .attr("x",0 )
        .attr("height",yScale.bandwidth())
        .attr("key",() => ++keyCounter)

      : this.g.selectAll("g.series")
        .data(stackedSeries)
        .enter().append("g")
        .attr("class","series")
        .attr("fill",(item,index) => color(item.key))
        .selectAll("rect")
        .data(data=>data)
        .enter().append("rect")
        .attr("y",data=> 0)
        .attr("x",data=> xScale(data[0]) )
        .attr("height",yScale.bandwidth())
        .attr("key",() => ++keyCounter);


        this.list[this.currentSelectedItem]['multiselect']
          ? this.breakdownByCompanySize
            .attr("width",0)
            .transition()
            .duration(1400)
            .attr("width",d=> xScale(d.value))

          : this.breakdownByCompanySize
            .attr("width",0)
            .transition()
            .duration(1400)
            .attr("width",_d=> xScale(_d[1]) - xScale(_d[0]));

        // generate legend
        d3.select(className+'__legend').selectAll('*').remove();
        d3.select(className+'__legend').selectAll('p')
          .data(stackedSeries)
          .enter().append('p')
          .attr("class","companySizeBreakdown__legend")
          .style('color','white')
          .style('font-weight',400)
          .style('font-family','Roboto')
          .style('font-size','16px')
          .text((item) =>{
            let Numerator = item[0].data[ item.key ]
            if(this.state.mode === 'percentage'){
              return d3.format('.1%')(Numerator / breakdownCounter) + ' of the participant selected '
            }else if (this.state.mode === 'absoluteNum'){
              return Numerator + ' participants selected '
            }
          })
          .append('em')
          .text((item) => optionMap[item.key])

          .style('position','relative')
          .style('margin','0px 30px 20px 0px')
          .style('margin-left','10px')

          .style('padding','2px 5px')
          .style('font-style','normal')
          .style('letter-spacing','0.2px')
          .style('font-size','14px')
          .style('color','white')
          .style('font-weight',300)
          .style('border-radius','3px')
          .style('background',(item) => {
            if(this.list[this.currentSelectedItem]['SDGColor']){
              return sdg_color(item.key);
            }
            return color(item.key)
          })
    }) // foreach
  }


  generateChartContainer(){
    const JSX = [];
    Object.keys(sizeLookup).forEach(d =>{
      let categoryName = d.replace(/\s/gi,'');
      JSX.push( (
        <div key ={categoryName}>
          <ChartContainer className={categoryName} svg-H={this.state.svg_height} currentOpenedTab={this.state.currentOpenedTab}>
            <p onClick={() =>this.handleTabClick(categoryName)}>company's size : <em>{d}</em></p>
            <p onClick={() =>this.handleTabClick(categoryName)}>{this.state.currentOpenedTab.includes(categoryName)?'-':'+'}</p>
            <svg>
              <g className="graphLayer"/>
            </svg>
          </ChartContainer>
          <LegendContainer className={categoryName+'__legend'} tabName={categoryName} currentOpenedTab={this.state.currentOpenedTab} >
          </LegendContainer>
        </div>
      ) )
    })
    return JSX;
  }

  render(){

    return(
      <Wrapper>
        <ModeContainer>
          <ModeSwitcher currentMode={this.state.mode} mode={'percentage'} onClick={() =>this.setState({  mode: 'percentage' },() => this.calculateChart() )} >Scale by Percentage</ModeSwitcher>
          <ModeSwitcher currentMode={this.state.mode} mode={'absoluteNum'} onClick={() =>this.setState({ mode:'absoluteNum' },() => this.calculateChart() )} >Scale by Absolute Num</ModeSwitcher>
        </ModeContainer>
        <Notes>(Click title to open/collapse tabs.)</Notes>
        {this.generateChartContainer()}
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/CompanySizeChart.js